export const LOAD_USERS = 'admin/LOAD_USERS'
export const LOAD_ROLES = 'admin/LOAD_ROLES'

export const SET_USERS_FILTERS_ROLES = 'admin/SET_USERS_FILTERS_ROLES'
export const SET_USERS_FILTERS_SORT_BY = 'admin/SET_USERS_FILTERS_SORT_BY'
